import React, { useState, useEffect, useFocus, useRef } from 'react'
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import { Form, Button } from 'react-bootstrap'
import Layout from '../../Component/Layout/Layout.js';
import DataTable from 'react-data-table-component';
import { SnackbarProvider, useSnackbar } from "notistack";
import { APIUrl } from '../../Helper/APIUrl.js';
import { handleKeyPress, handleKeyPressString } from '../../Helper/Helper.js';

const quillModules = {
    toolbar: [
        [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }, { align: [] }],
        ['blockquote', 'code-block'],
        ['link', 'image', 'video'],
        ['clean']
    ],
    history: {
        delay: 500,
        maxStack: 100,
        userOnly: true
    },
    clipboard: {
        matchVisual: false
    }
};

const quillFormats = [
    'font',
    'size',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'script',
    'list',
    'bullet',
    'indent',
    'direction',
    'align',
    'blockquote',
    'link',
    'image',
    'video',
    'code-block'
];

const ALLOWED_IMAGE_EXTENSIONS = /\.(jpg|jpeg|png)$/i;
const MAX_EDITOR_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;

const getPlainTextFromHtml = (html) => {
    if (!html) {
        return '';
    }

    return html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim();
};


function CreateProfile() {

    const Token = JSON.parse(localStorage.getItem('tcn'));
    const localStorageUserId = JSON.parse(localStorage.getItem('userid'));

    const { enqueueSnackbar } = useSnackbar();

    const [val, setVal] = useState(0);
    const [search, setsearch] = useState("");
    const [AUserProfile, setAUserProfile] = useState([]);
    const [filterAUserProfile, setfilterAUserProfile] = useState([]);
    const [DistrictList, setDistrictList] = useState([]);

    const [error, seterror] = useState("NOERROR");

    //Use Ref for Focus
    const NameRef = useRef(null);
    const EmailRef = useRef(null);
    const PhoneRef = useRef(null);
    const JobProfileRef = useRef(null);
    const AddressRef = useRef(null);


    //Insert and Update UseStates
    const [UserID, setUserID] = useState("");

    const [ProfileId, setProfileId] = useState("");
    const [Name, setName] = useState("");
    const [Email, setEmail] = useState("");
    const [Phone, setPhone] = useState("");
    const [JobProfile, setJobProfile] = useState("");
    const [Address, setAddress] = useState("");
    const [ShortDescription, setShortDescription] = useState("");
    const [PhotoAltText, setPhotoAltText] = useState("");
    const [ProfileURL, setProfileURL] = useState("");
    const [Photo, setPhoto] = useState("");
    const [OldPhoto, setOldPhoto] = useState("");
    const [PhotoPreview, setPhotoPreview] = useState("");
    const [Facebook, setFacebook] = useState("");
    const [Instagram, setInstagram] = useState("");
    const [Twitter, setTwitter] = useState("");
    const [Youtube, setYoutube] = useState("");
    const [LinkDin, setLinkDin] = useState("");
    const [IsActive, setisactive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(localStorageUserId);
    const [ModifiedBy, setModifiedBy] = useState(localStorageUserId);

    //Edit Populates States
    const [edit, setEdit] = useState(false);
    const [returnId, setreturnId] = useState(0);

    //API : Base Url + Controller Name
    const ConcateURL = APIUrl.AUserProfile;
    const ConcateURL_SZType = APIUrl.SZType;

    // Safe JSON parse helper to avoid "Unexpected end of JSON input"
    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const generateProfileURL = (value) => {
        const plainValue = getPlainTextFromHtml(value || "");

        return plainValue
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function doEmptyStates() {
        setName("");
        setEmail("");
        setPhone("");
        setPhoto("");
        setPhotoPreview("");
        setAddress("");
        setJobProfile("");
        setShortDescription("");
        setPhotoAltText("");
        setProfileURL("");
        setFacebook("");
        setInstagram("");
        setTwitter("");
        setYoutube("");
        setLinkDin("");
        setisactive(true);
        setEdit(false)

        // Clear file input DOM control (so the file chooser resets)
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            try { fileInput.value = "" } catch (e) { /* ignore in older browsers */ }
        }
    }

    const getAllAUserProfiles = async () => {
        try {
            const response = await fetch(ConcateURL + 'GetAllAUserProfile',
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify({})
                });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await parseJSON(response);
            if (result && result.data !== null) {
                setAUserProfile(result.data);
                setfilterAUserProfile(result.data);
            }
            else {
                setAUserProfile([]);
                setfilterAUserProfile([]);
            }
        }
        catch (error) {
            console.error("Error fetching user profiles:", error);
            setAUserProfile([]);
            setfilterAUserProfile([]);
        }
    };


    useEffect(() => {
        if (!Token) {
            console.warn("No token found. Please login first.");
            // Redirect to login: window.location.href = '/login';
            enqueueSnackbar("Please login first", { variant: "warning" });
            return;
        }
        getAllAUserProfiles();
    }, []);



    const insertAUserProfiles = async () => {
        try {
            // Create FormData for multipart request
            const formData = new FormData();

            // Add JSON profile as string in "profileJson" field
            const profileData = {
                Name, Email, Phone,
                Address, JobProfile,
                ShortDescription,
                PhotoAltText,
                ProfileURL,
                IsActive, CreatedBy, ModifiedBy, Facebook, Instagram, Twitter, Youtube, LinkDin // Note: Match your model property name
            };
            formData.append('profileJson', JSON.stringify(profileData));

            // Add photo file (from file input ref or state)
            if (Photo && Photo instanceof File) {
                formData.append('photo', Photo); // Photo should be File object
            } else {
                enqueueSnackbar("Please select a photo file", { variant: "error" });
                return;
            }

            const response = await fetch(ConcateURL + 'InsertAUserProfile', {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${Token}`
                    // Note: Do NOT set Content-Type for FormData - browser sets multipart boundary
                },
                body: formData
            });

            const result = await response.json();

            if (result.isSuccess && result.Message === "Success") {
                setreturnId(result.returnID);
                getAllAUserProfiles();
                doEmptyStates();
                enqueueSnackbar("Successfully Added", { variant: "success" });
            } else {
                enqueueSnackbar(result.Message || "Failed to add user", { variant: "error" });
            }
        } catch (error) {
            console.error("Error:", error);
            enqueueSnackbar("Error adding user profile", { variant: "error" });
        }
    };


    const ValidateAusersandSubmit = async () => {
        try {

            if (!Name || Name.length <= 3) {
                enqueueSnackbar("name must be greater than 3 characters", { variant: "warning" });
                NameRef.current.focus();
                return false;
            }

            if (!Email || Email.length <= 3) {
                enqueueSnackbar("email is required", { variant: "warning" });
                EmailRef.current.focus();
                return false;
            }

            if (!new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(Email)) {
                enqueueSnackbar("valid email must contain @ , .  ", { variant: "warning" });
                EmailRef.current.focus();
                return false;
            }

            if (!Phone || Phone.length <= 3) {
                enqueueSnackbar("phone is required", { variant: "warning" });
                PhoneRef.current.focus();
                return false;
            }

            if (!JobProfile || JobProfile.length <= 3) {
                enqueueSnackbar("job profile is required", { variant: "warning" });
                JobProfileRef.current.focus();
                return false;
            }

            if (!Address || Address.length <= 3) {
                enqueueSnackbar("address is required", { variant: "warning" });
                AddressRef.current.focus();
                return false;
            }

            insertAUserProfiles()

        }
        catch (error) {
            console.log(error);
        }
    };

    const coloumn = [
        {
            name: "SNo.",
            selector: (row, index) => index + 1
        },
        {
            name: "Name",
            selector: (row) => row.Name,
            sortable: true,
            reorder: true
        },
        {
            name: "Email",
            selector: (row) => row.Email,
        },
        {
            name: "Phone",
            selector: (row) => row.Phone,
        },
        {
            name: "Photo",
            selector: (row) => row.Photo,
        },
        {
            name: "Address",
            selector: (row) => row.Address,
        },
        {
            name: "JobProfile",
            selector: (row) => row.JobProfile,
        },
        {
            name: <strong>Activated/Deactivated</strong>,
            selector: (row) => row.IsActive ? <label class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label> : <label class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-yellow-800">Deactivated</label>,
        },
        {
            name: "Action",
            cell: row =>
                <div>

                    {
                        <>
                            {
                                !row.IsActive
                                    ?
                                    <Button onClick={() => activateDeactiveAUserProfile(row.ProfileId, "activate")} data-tip="Click to Activate User" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-toggle-off" aria-hidden="true"></i></Button>
                                    :
                                    <Button onClick={() => activateDeactiveAUserProfile(row.ProfileId, "deactivate")} data-tip="Click to Deactivate User" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-toggle-on" aria-hidden="true"></i></Button>
                            }
                        </>
                    }&nbsp;&nbsp;
                    <Button onClick={() => editAUserProfiles(row.ProfileId)} data-tip="Click to Edit Details" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-pencil" aria-hidden="true"></i></Button>

                    {/* <Button onClick={() => DeleteAUserProfiles(row.ProfileId)} data-tip="Click to Delete" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-trash" aria-hidden="true"></i></Button> */}
                </div>
        }
    ];

    const editAUserProfiles = async (Id) => {
        try {
            let items = AUserProfile.filter(x => {
                return x.ProfileId === Id;
            });

            items.map(item => {
                setProfileId(item.ProfileId)
                setName(item.Name)
                setEmail(item.Email)
                setPhone(item.Phone)
                setPhoto(item.Photo)
                setOldPhoto(item.Photo)
                setJobProfile(item.JobProfile)
                setAddress(item.Address)
                setShortDescription(item.ShortDescription || "")
                setPhotoAltText(item.PhotoAltText || "")
                setProfileURL(item.ProfileURL || generateProfileURL(item.Name || ""))
                setFacebook(item.Facebook)
                setInstagram(item.Instagram)
                setTwitter(item.Twitter)
                setYoutube(item.Youtube)
                setLinkDin(item.LinkDin)

                setreturnId(item.ProfileId);
                setPhotoPreview(APIUrl.BaseUrl + item.Photo);

            })
            setEdit(true)
            NameRef.current.focus();
        }
        catch (error) {
            console.log(error);
        }
    };


    // const updateAUserProfiles = async (Id) => {
    //     try {
    //         if (Name.length > 3 && Email.length > 3 && Phone.length > 3 && JobProfile.length > 3 && Address.length > 3) {

    //             let data = { Name, Email, Phone, JobProfile, Address, ModifiedBy }
    //             fetch(ConcateURL + 'UpdateAUserProfile/' + Id,
    //                 {
    //                     method: "Post",
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Authorization': `Bearer ${Token}`
    //                     },
    //                     body: JSON.stringify(data)
    //                 })
    //                 .then((response) => {
    //                     parseJSON(response).then((result) => {
    //                         if (result) setreturnId(result.returnID);

    //                         getAllAUserProfiles();
    //                         doEmptyStates();
    //                         enqueueSnackbar("Successfully Updated", { variant: "success" });
    //                     })
    //                 })
    //         }
    //         else {
    //             alert("fill all the required details to update")
    //         }

    //     }
    //     catch (error) {
    //         console.log(error);
    //     }
    // };

    const updateAUserProfiles = async (Id) => {
        try {
            // Validation
            if (Name.length <= 3 || Email.length <= 3 || Phone.length <= 3 ||
                JobProfile.length <= 3 || Address.length <= 3) {
                enqueueSnackbar("Fill all required details to update", { variant: "error" });
                return;
            }

            // Create FormData for multipart request (same as insert)
            const formData = new FormData();

            // Add JSON profile as string in "profileJson" field (include ID)
            const profileData = {
                ProfileId: Id,
                Name,
                Email,
                Phone,
                OldPhoto,
                Address,
                JobProfile,
                ShortDescription,
                PhotoAltText,
                ProfileURL,
                IsActive,
                ModifiedBy,
                Facebook,
                Instagram,
                Twitter,
                Youtube,
                LinkDin

            };
            formData.append('profileJson', JSON.stringify(profileData));

            // Add photo file if changed (optional for update)
            if (Photo && Photo instanceof File) {
                formData.append('photo', Photo);
            }

            const response = await fetch(ConcateURL + 'UpdateAUserProfile/' + Id, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${Token}`
                    // No Content-Type - browser sets multipart boundary automatically
                },
                body: formData
            });

            const result = await response.json();

            if (result.isSuccess && result.Message === "Success") {
                setreturnId(result.returnID);
                getAllAUserProfiles();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" });
            } else {
                enqueueSnackbar(result.Message || "Failed to update user", { variant: "error" });
            }
        } catch (error) {
            console.error("Error:", error);
            enqueueSnackbar("Error updating user profile", { variant: "error" });
        }
    };


    const activateDeactiveAUserProfile = async (Id, Value) => {
        try {
            debugger;
            let data = { UserId: Id, Value }
            fetch(ConcateURL + 'ActivateDeactivateAUserProfile/' + Id,
                {
                    method: "Post",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                })
                .then((response) => {
                    parseJSON(response).then((result) => {
                        if (result) setreturnId(result.returnID);

                        getAllAUserProfiles();
                        doEmptyStates();

                        Value == "activate" ?
                            enqueueSnackbar("Successfully Activated", { variant: "success" })
                            :
                            enqueueSnackbar("Successfully Dectivated", { variant: "warning" });
                    })
                })
        }
        catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const query = search.trim().toLowerCase();

        if (!query) {
            setfilterAUserProfile(AUserProfile);
            return;
        }

        const result = AUserProfile.filter(x => {
            const searchableText = [
                x.Name,
                x.Email,
                x.Phone,
                x.Photo,
                x.Address,
                x.JobProfile,
                getPlainTextFromHtml(x.ShortDescription || ''),
                x.PhotoAltText,
                x.ProfileURL,
                x.Facebook,
                x.Instagram,
                x.Twitter,
                x.Youtube,
                x.IsActive ? 'activated' : 'deactivated'
            ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();

            return searchableText.includes(query);
        });

        setfilterAUserProfile(result);
    }, [search, AUserProfile]);

    useEffect(() => {
        setProfileURL(Name ? generateProfileURL(Name) : "");
    }, [Name]);


    const tableData = { coloumn, filterAUserProfile };

    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                            <h2 className="text-xl font-semibold text-gray-900 mb-6">
                                User Profile
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                                {
                                    Photo && !PhotoPreview && (
                                        <img
                                            src={URL.createObjectURL(Photo)}
                                            alt="User Profile"
                                            className="w-full h-48 object-cover rounded-lg border border-gray-300"
                                        />
                                    )
                                }
                                {
                                    PhotoPreview && (
                                        <img
                                            src={PhotoPreview}
                                            alt="User Profile"
                                            className="w-full h-48 object-cover rounded-lg border border-gray-300"
                                        />
                                    )
                                }

                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                                <div>
                                    <label htmlFor="photo" className="block text-sm font-medium text-gray-700 mb-2">
                                        Photo
                                    </label>
                                    <input
                                        type="file"
                                        accept=".jpg,.jpeg,.png"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                                if (file.size > 500 * 1024) {
                                                    enqueueSnackbar("File size must be less than 500KB", { variant: "warning" });
                                                    e.target.value = "";
                                                    return;
                                                }
                                                if (!["image/jpeg", "image/png"].includes(file.type)) {
                                                    enqueueSnackbar("Only JPG, JPEG, and PNG files are allowed", { variant: "warning" });
                                                    e.target.value = "";
                                                    return;
                                                }
                                                setPhoto(file);
                                                setPhotoPreview("");
                                                const reader = new FileReader();
                                                reader.onload = (event) => {
                                                    // Store preview separately if needed for display
                                                };
                                                reader.readAsDataURL(file);
                                            }
                                        }}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                    <p className="text-xs text-gray-500 mt-2">Max size: 500KB (JPG, JPEG, PNG)</p>
                                </div>
                                <div>
                                    <label htmlFor="photoalttext" className="block text-sm font-medium text-gray-700 mb-2">
                                        Photo Alt Text
                                    </label>
                                    <input
                                        type="text"
                                        value={PhotoAltText}
                                        onChange={(e) => { setPhotoAltText(e.target.value) }}
                                        placeholder="Enter Photo Alt Text"
                                        maxLength={100}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
                                <div>
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        ref={NameRef}
                                        value={Name}
                                        onChange={(e) => { setName(e.target.value) }}
                                        placeholder="Enter Name"
                                        onKeyDown={handleKeyPressString}
                                        maxLength={50}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>



                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        ref={EmailRef}
                                        value={Email}
                                        onChange={(e) => { setEmail(e.target.value) }}
                                        placeholder="Enter Email"
                                        maxLength={60}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                                        Phone
                                    </label>
                                    <input
                                        type="text"
                                        ref={PhoneRef}
                                        value={Phone}
                                        onChange={(e) => { setPhone(e.target.value) }}
                                        placeholder="Enter Phone"
                                        onKeyDown={handleKeyPress}
                                        maxLength={10}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="jobprofile" className="block text-sm font-medium text-gray-700 mb-2">
                                        Job Profile
                                    </label>
                                    <input
                                        type="text"
                                        ref={JobProfileRef}
                                        value={JobProfile}
                                        onChange={(e) => { setJobProfile(e.target.value) }}
                                        placeholder="Enter Job Profile"
                                        onKeyDown={handleKeyPressString}
                                        maxLength={50}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="profileurl" className="block text-sm font-medium text-gray-700 mb-2">
                                        Profile URL: {ProfileURL || 'auto-generated from name'}
                                    </label>
                                    <input
                                        type="text"
                                        value={ProfileURL}
                                        placeholder="Profile URL"
                                        disabled
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 cursor-not-allowed"
                                    />
                                </div>

                            </div>
                            <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                                        Address
                                    </label>
                                    <input
                                        type="text"
                                        ref={AddressRef}
                                        value={Address}
                                        onChange={(e) => { setAddress(e.target.value) }}
                                        placeholder="Enter Address"
                                        onKeyDown={handleKeyPressString}
                                        maxLength={50}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="shortdescription" className="block text-sm font-medium text-gray-700 mb-2">
                                        Short Description
                                    </label>
                                    <HtmlEditor
                                        value={ShortDescription}
                                        onChange={setShortDescription}
                                        placeholder="Enter Short Description"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                                        Facebook
                                    </label>
                                    <input
                                        type="text"
                                        value={Facebook}
                                        onChange={(e) => { setFacebook(e.target.value) }}
                                        placeholder="Enter Facebook URL"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                                        Instagram
                                    </label>
                                    <input

                                        type="text"
                                        value={Instagram}
                                        onChange={(e) => { setInstagram(e.target.value) }}
                                        placeholder="Enter Instagram URL"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                                        Twitter
                                    </label>
                                    <input
                                        type="text"
                                        value={Twitter}
                                        onChange={(e) => { setTwitter(e.target.value) }}
                                        placeholder="Enter Twitter URL"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                                        Youtube
                                    </label>
                                    <input
                                        type="text"
                                        value={Youtube}
                                        onChange={(e) => { setYoutube(e.target.value) }}
                                        placeholder="Enter Youtube URL"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>
                             <div className="grid grid-cols-12 md:grid-cols-12 gap-6 mt-5">
                                <div className="col-span-12">
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                                        LinkDin
                                    </label>
                                    <input
                                        type="text"
                                        value={LinkDin}
                                        onChange={(e) => { setLinkDin(e.target.value) }}
                                        placeholder="Enter LinkDin URL"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-4 mt-3">
                                {
                                    edit ? <Button
                                        className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                        onClick={() => updateAUserProfiles(ProfileId)}
                                    >
                                        <span>Update</span>
                                    </Button> :
                                        <Button
                                            className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                            onClick={() => ValidateAusersandSubmit()}
                                        >
                                            <span>Submit</span>
                                        </Button>
                                }


                                <button
                                    type="button"
                                    onClick={() => doEmptyStates()}
                                    className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                                >
                                    Reset
                                </button>

                            </div>
                        </div>
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                            <div class="overflow-x-auto">
                                <DataTable
                                    title="Manage User Profiles"
                                    columns={coloumn}
                                    data={filterAUserProfile}
                                    pagination
                                    fixedHeader
                                    fixedHeaderScrollHeight="550px"
                                    selectableRows
                                    selectableRowsHighlight
                                    highlightOnHover  // actions={<button className="btn btn-sm btn-info">Export</button>}                                                
                                    subHeader
                                    subHeaderAlign="right"
                                    subHeaderComponent={
                                        <input type="text"
                                            placeholder="search username"
                                            className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            value={search}
                                            onChange={(e) => setsearch(e.target.value)}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </Layout >

        </div >
    )
}


function HtmlEditor({ value, onChange, placeholder = '', onReady }) {
    const editorImageInputRef = useRef(null);
    const { quill, quillRef } = useQuill({
        theme: 'snow',
        modules: quillModules,
        formats: quillFormats,
        placeholder
    });

    useEffect(() => {
        if (quill && onReady) {
            onReady(quill);
        }
    }, [quill, onReady]);

    useEffect(() => {
        if (!quill) {
            return;
        }

        const toolbar = quill.getModule('toolbar');
        if (!toolbar) {
            return;
        }

        const handleInsertLink = () => {
            const url = window.prompt('Enter link URL');
            if (!url) {
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertText(index, url, 'link', url, 'user');
            quill.setSelection(index + url.length, 0, 'user');
        };

        const handleInsertImage = () => {
            editorImageInputRef.current?.click();
        };

        const handleInsertVideo = () => {
            const videoUrl = window.prompt('Enter YouTube/Vimeo embed URL');
            if (!videoUrl) {
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'video', videoUrl, 'user');
            quill.setSelection(index + 1, 0, 'user');
        };

        toolbar.addHandler('link', handleInsertLink);
        toolbar.addHandler('image', handleInsertImage);
        toolbar.addHandler('video', handleInsertVideo);
    }, [quill]);

    const handleEditorImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file || !quill) {
            return;
        }

        const isValidType = ['image/jpeg', 'image/png'].includes(file.type) || ALLOWED_IMAGE_EXTENSIONS.test(file.name);
        if (!isValidType) {
            window.alert('Only JPG, JPEG, or PNG files are allowed in the editor.');
            event.target.value = '';
            return;
        }

        if (file.size > MAX_EDITOR_IMAGE_SIZE_BYTES) {
            window.alert('Editor image size must be less than or equal to 2 MB.');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = typeof reader.result === 'string' ? reader.result : '';
            if (!base64) {
                event.target.value = '';
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'image', base64, 'user');
            quill.setSelection(index + 1, 0, 'user');
            event.target.value = '';
        };

        reader.readAsDataURL(file);
    };

    useEffect(() => {
        if (!quill) {
            return;
        }

        const nextValue = value || '';
        const currentValue = quill.root.innerHTML === '<p><br></p>' ? '' : quill.root.innerHTML;

        if (currentValue !== nextValue) {
            if (nextValue) {
                quill.clipboard.dangerouslyPasteHTML(nextValue);
            }
            else {
                quill.setText('');
            }
        }
    }, [quill, value]);

    useEffect(() => {
        if (!quill) {
            return;
        }

        const handleChange = () => {
            const html = quill.root.innerHTML;
            onChange(html === '<p><br></p>' ? '' : html);
        };

        quill.on('text-change', handleChange);

        return () => {
            quill.off('text-change', handleChange);
        };
    }, [quill, onChange]);

    return (
        <div className="overflow-hidden rounded-md border border-slate-300 bg-white [&_.ql-container]:min-h-[220px] [&_.ql-container]:border-0 [&_.ql-editor]:min-h-[220px] [&_.ql-editor]:text-sm [&_.ql-toolbar]:border-x-0 [&_.ql-toolbar]:border-t-0">
            <input
                ref={editorImageInputRef}
                type="file"
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                className="hidden"
                onChange={handleEditorImageChange}
            />
            <div ref={quillRef} />
        </div>
    );
}

export default CreateProfile